import actionCreator from '../../shared/decorators/actionCreator';
import { REDUX_NAMESPACE } from '../constants';

const ACTION_CREATORS = {
  @actionCreator(REDUX_NAMESPACE)
  loadDiscoverPublisher(publisherId) {
    return { publisherId };
  },

  @actionCreator(REDUX_NAMESPACE)
  setDiscoverPublisher(discoverPublisher) {
    return { discoverPublisher };
  },
};

export default ACTION_CREATORS;
